import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/images/icons/tip-red.svg';
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row mt-4"
};
const _hoisted_3 = {
  class: "col-12"
};
const _hoisted_4 = {
  class: "pl-2 pr-2"
};
const _hoisted_5 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_6 = {
  class: "mr-1"
};
const _hoisted_7 = {
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_8 = {
  class: "fw-bold fsi-24"
};
const _hoisted_9 = {
  class: "row mt-4"
};
const _hoisted_10 = {
  class: "col-12"
};
const _hoisted_11 = {
  class: "pl-2 pr-2"
};
const _hoisted_12 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_13 = {
  class: "mr-1"
};
const _hoisted_14 = {
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_15 = {
  class: "fw-bold fsi-24"
};
const _hoisted_16 = {
  class: "row mt-4"
};
const _hoisted_17 = {
  class: "col-12"
};
const _hoisted_18 = {
  class: "pl-2 pr-2"
};
const _hoisted_19 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_20 = {
  class: "mr-1"
};
const _hoisted_21 = {
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_22 = {
  class: "fw-bold fsi-24"
};
const _hoisted_23 = {
  class: "fw-bold fsi-16 mt-1"
};
const _hoisted_24 = {
  class: "row mt-4"
};
const _hoisted_25 = {
  class: "col-lg-6 col-12"
};
const _hoisted_26 = {
  class: "pl-2 pr-2"
};
const _hoisted_27 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_28 = {
  class: "mr-1"
};
const _hoisted_29 = {
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_30 = {
  class: "fw-bold fsi-24"
};
const _hoisted_31 = {
  class: "fw-bold fsi-24"
};
const _hoisted_32 = {
  class: "row mt-lg-3 mt-4"
};
const _hoisted_33 = {
  class: "col-lg-6 col-12"
};
const _hoisted_34 = {
  class: "pl-2 pr-2"
};
const _hoisted_35 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_36 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_37 = {
  class: "fw-bold fsi-24"
};
const _hoisted_38 = {
  class: "fw-bold fsi-24"
};
const _hoisted_39 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-4"
};
const _hoisted_40 = {
  class: "pl-2 pr-2"
};
const _hoisted_41 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_42 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_43 = {
  class: "fw-bold fsi-24"
};
const _hoisted_44 = {
  class: "fw-bold fsi-24"
};
const _hoisted_45 = {
  class: "row mt-lg-3 mt-4"
};
const _hoisted_46 = {
  class: "col-lg-6 col-12"
};
const _hoisted_47 = {
  class: "pl-2 pr-2"
};
const _hoisted_48 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_49 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_50 = {
  class: "fw-bold fsi-24"
};
const _hoisted_51 = {
  class: "fw-bold fsi-24"
};
const _hoisted_52 = {
  class: "col-lg-6 col-12"
};
const _hoisted_53 = {
  class: "pl-2 pr-2"
};
const _hoisted_54 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-1",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_55 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_56 = {
  class: "fw-bold fsi-24"
};
const _hoisted_57 = {
  class: "fw-bold fsi-16"
};
const _hoisted_58 = {
  class: "row mt-2"
};
const _hoisted_59 = {
  class: "col-12"
};
const _hoisted_60 = {
  class: "pl-4 pr-4"
};
const _hoisted_61 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_62 = {
  class: "mr-1 fw-bold fsi-14"
};
const _hoisted_63 = {
  key: 1,
  class: "mt-4"
};
const _hoisted_64 = {
  key: 2,
  class: "mt-4"
};
const _hoisted_65 = {
  class: "row mt-2"
};
const _hoisted_66 = {
  class: "col-12"
};
const _hoisted_67 = {
  class: "pl-4 pr-4"
};
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "Original Beneficiary")], -1);
const _hoisted_69 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_70 = {
  class: "fw-medium",
  style: {
    "width": "80px",
    "color": "#787A9B"
  }
};
const _hoisted_71 = {
  class: "fw-bold"
};
const _hoisted_72 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_73 = {
  class: "row mt-2"
};
const _hoisted_74 = {
  class: "col-12"
};
const _hoisted_75 = {
  class: "pl-4 pr-4"
};
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 fw-bold fsi-16"
}, "Original Owner")], -1);
const _hoisted_77 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_78 = {
  class: "fw-medium",
  style: {
    "width": "80px",
    "color": "#787A9B"
  }
};
const _hoisted_79 = {
  class: "fsi-14 d-flex align-items-center"
};
const _hoisted_80 = {
  class: "row mt-lg-4 mt-4"
};
const _hoisted_81 = {
  class: "col-lg-6 col-12"
};
const _hoisted_82 = {
  class: "pl-2 pr-2"
};
const _hoisted_83 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_84 = {
  class: "mr-1"
};
const _hoisted_85 = {
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_86 = {
  class: "fw-bold fsi-24"
};
const _hoisted_87 = {
  key: 0,
  class: "mr-1 fsi-14",
  style: {
    "color": "red"
  }
};
const _hoisted_88 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "20px",
    "cursor": "pointer",
    "transform": "translateY(-1px)",
    "margin-right": "2px"
  },
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_89 = {
  class: "fw-bold"
};
const _hoisted_90 = {
  class: "row mt-lg-3 mt-4"
};
const _hoisted_91 = {
  class: "col-12"
};
const _hoisted_92 = {
  class: "pl-2 pr-2"
};
const _hoisted_93 = {
  class: "fw-bold fsi-18 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_94 = {
  class: "mr-1"
};
const _hoisted_95 = {
  class: "row mt-lg-2 mt-3"
};
const _hoisted_96 = {
  class: "col-lg-6 col-12"
};
const _hoisted_97 = {
  class: "pl-2 pr-2"
};
const _hoisted_98 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_99 = {
  class: "mr-1"
};
const _hoisted_100 = {
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_101 = {
  class: "fw-bold fsi-24"
};
const _hoisted_102 = {
  class: "fw-bold fsi-24"
};
const _hoisted_103 = {
  class: "col-lg-6 col-12 mt-lo-0 mt-2"
};
const _hoisted_104 = {
  class: "pl-2 pr-2"
};
const _hoisted_105 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_106 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_107 = {
  class: "fw-bold fsi-24"
};
const _hoisted_108 = {
  class: "fw-bold fsi-24"
};
const _hoisted_109 = {
  class: "fw-bold fsi-24"
};
const _hoisted_110 = {
  key: 3,
  class: "row mt-3"
};
const _hoisted_111 = {
  class: "col-12 mt-3"
};
const _hoisted_112 = {
  key: 4,
  class: "mt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_Tip = _resolveComponent("Tip");
  const _component_SubPoolSearchNode = _resolveComponent("SubPoolSearchNode");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('subpool.poolInfoTip.poolAddress')), 1)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "fw-bold fsi-16 mt-1 link-text-ordinary",
      onClick: _cache[0] || (_cache[0] = $event => $options.gotoAddress(_ctx.currentPoolAddress, _ctx.$i18n.locale))
    }, _toDisplayString(_ctx.currentPoolAddress), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('subpool.induction.admin')), 1)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "fw-bold fsi-16 mt-1 link-text-ordinary",
      onClick: _cache[1] || (_cache[1] = $event => $options.gotoAddress(_ctx.poolAdmin, _ctx.$i18n.locale))
    }, _toDisplayString(_ctx.poolAdmin), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('subpool.poolType')), 1)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('subpool.Storage Provider')), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('subpool.poolPosition')), 1)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_31, _toDisplayString($options.formatWalletFilPrice(_ctx.poolPosition)), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('subpool.MaxSealLoadLeverage')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_38, _toDisplayString((parseFloat((_ctx.maxSealLoadLeverage / 10000000000000000n).toString()) / 100).toFixed(2)) + " x ", 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('subpool.poolMaxWithdrawLoadLeverage')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_44, _toDisplayString((parseFloat((_ctx.maxWithdrawLoadLeverage / 10000000000000000n).toString()) / 100).toFixed(2)) + " x ", 1)]),
    _: 1
  }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('subpool.nodeCount')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.nodeCount) + " / 20 ", 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('subpool.Entry requirement')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.poolInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.onlyAcceptsNewNodes ? _ctx.$t('subpool.The node balance is less than') : _ctx.$t('subpool.none')), 1)]),
    _: 1
  }, 8, ["loading"])])])]), !_ctx.poolInfoLoading && _ctx.nodeCount >= _ctx.maxNodeCount ? (_openBlock(), _createBlock(_component_Tip, {
    key: 0,
    level: "warring"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('subpool.induction.nodeFull')), 1)])])])])]),
    _: 1
  })) : _createCommentVNode("", true), !_ctx.poolInfoLoading && _ctx.nodeCount < _ctx.maxNodeCount ? (_openBlock(), _createElementBlock("div", _hoisted_63, [_createVNode(_component_SubPoolSearchNode, {
    ref: "searchNode",
    onSearchOK: $options.searchResult,
    onSearchFail: $options.searchResultFail
  }, null, 8, ["onSearchOK", "onSearchFail"])])) : _createCommentVNode("", true), $data.searchOk ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_ctx.isOnlyNewNodeCanNext ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.nodeInfo.owner !== _ctx.nodeInfo.beneficiary && !$data.haveSp ? (_openBlock(), _createBlock(_component_Tip, {
    key: 0,
    level: "warring"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('Onboarding.Address')) + ":", 1), _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.nodeInfo['beneficiary']), 1)]), _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('Onboarding.There can be no other beneficiaries')), 1)])])])]),
    _: 1
  })) : _createCommentVNode("", true), _ctx.nodeInfo.owner === _ctx.nodeInfo.beneficiary && !$data.haveSp ? (_openBlock(), _createBlock(_component_Tip, {
    key: 1
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_hoisted_76, _createElementVNode("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('Onboarding.Address')) + ":", 1), _createElementVNode("div", {
      class: "fw-bold link-text-ordinary",
      onClick: _cache[2] || (_cache[2] = $event => $options.gotoAddress(_ctx.nodeInfo[_ctx.radio1.toString().toLowerCase()], _ctx.$i18n.locale))
    }, _toDisplayString(_ctx.nodeInfo[_ctx.radio1.toString().toLowerCase()]), 1)]), _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.$t('Onboarding.AddressTips1')), 1)])])])]),
    _: 1
  })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("span", _hoisted_84, [_createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.$t('subpool.node position')), 1)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "fw-bold fsi-24",
      style: _normalizeStyle({
        color: _ctx.isOnlyNewNodeCanNext ? '' : 'red'
      })
    }, _toDisplayString(!$data.searchOk ? '--' : $options.formatWalletFilPrice(_ctx.positionValue)), 5)]),
    _: 1
  }, 8, ["loading"]), !_ctx.loading && !_ctx.isOnlyNewNodeCanNext ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_hoisted_88, _createTextVNode(), _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.$t('subpool.The node balance is less than 3')) + "!", 1)])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, [_createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.$t('subpool.induction.Pool Will Receive')), 1)])])])]), _createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_createElementVNode("span", _hoisted_99, [_createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.$t('subpool.induction.maxLoan')), 1)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_101, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_102, _toDisplayString(!$data.searchOk ? '--' : $options.formatWalletFilPrice(_ctx.availableBorrowingAmount)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, [_createElementVNode("div", _hoisted_105, [_createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('subpool.induction.maxWith')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.loading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_107, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, _toDisplayString(!$data.searchOk ? '--' : $options.formatWalletFilPrice(_ctx.availableWithdrawLoadAmount)), 1)])]),
    _: 1
  }, 8, ["loading"])])])]), _ctx.isOnlyNewNodeCanNext && _ctx.nodeInfo.owner === _ctx.nodeInfo.beneficiary && !$data.haveSp ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.haveSp ? (_openBlock(), _createElementBlock("div", _hoisted_110, [_createElementVNode("div", _hoisted_111, [_createVNode(_component_AdCard2, {
    title: _ctx.$t('Onboarding.This node has been delegated!'),
    "btn-text": _ctx.$t('Onboarding.View Node'),
    content: _ctx.$t('Onboarding.Please take good care the original owner'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "btn-text", "content", "onBtnClick"])])])) : _createCommentVNode("", true), $data.searchOk && !$data.haveSp && _ctx.isOnlyNewNodeCanNext && _ctx.nodeInfo.owner === _ctx.nodeInfo.beneficiary ? (_openBlock(), _createElementBlock("div", _hoisted_112, [_ctx.isCanNext ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "btn btn-primary w-100 i-button",
    onClick: $options.next,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Next')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}